import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FilterControl, FilterControlComponent, FilterControlOptions, SelectOption } from './filter-control';

export interface SeachSelectOptions extends FilterControlOptions {
  searchDisplay?: (value: any) => string;
}

@Component({
  template: `
    <glxy-form-field [bottomSpacing]="'none'" [formGroup]="formGroup">
      <glxy-label *ngIf="control.label">{{ control.label | translate }}</glxy-label>
      <input
        type="text"
        placeholder="{{ control.label | translate }}"
        matInput
        [formControl]="control"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete" [panelWidth]="400" [displayWith]="control.opts.searchDisplay">
        <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option.value">
          {{ option.key | translate }}
        </mat-option>
      </mat-autocomplete>
    </glxy-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSelectFilterControlComponent implements FilterControlComponent, OnInit {
  control: SearchSelectFilterControl;
  formGroup: UntypedFormGroup;
  options$: Observable<SelectOption[]>;
  filteredOptions$: Observable<SelectOption[]>;

  ngOnInit(): void {
    if (!this.control.options$) {
      console.warn('SelectFilterControlComponent requires options$.');
      return;
    }
    this.options$ = this.control.options$.pipe(
      map((o) => {
        const options = [];
        // cannot map over a Map
        o.forEach((value, key) => options.push({ key, value }));
        return options;
      }),
    );
    this.filteredOptions$ = combineLatest([
      this.options$,
      this.control.valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : '')),
      ),
    ]).pipe(map(([options, searchTerm]) => this.filterOptions(options, searchTerm)));
  }

  private filterOptions(options: SelectOption[], name: string): SelectOption[] {
    const filterValue = name.toLowerCase();
    return options.filter(
      (option) => option.key.toLowerCase().includes(filterValue) || option.value.toLowerCase().includes(filterValue),
    );
  }
}

export class SearchSelectFilterControl extends FilterControl {
  component = SearchSelectFilterControlComponent;
  constructor(
    public name: string,
    public label?: string,
    public options$?: Observable<Map<string, any>>,
    formState?: any,
    public opts: SeachSelectOptions = {},
  ) {
    super(name, label, formState, opts);
    if (!this.options$) {
      console.warn('MultiSelectFilterControl requires options$ to be provided in order to function correctly.');
    }
  }
}
